module.exports = __webpack_public_path__ + "static/media/importUser.3d30bd67.svg";